export const optionKeySymbol = '\u2325';
export const commandKeySymbol = '\u2318';
export const ctrlKeySymbol = '\u2303';
export const horizontalEllipsis = '\u2026';
export const nbsp = '\u00a0';
export const ndash = '\u2013';
export const rightArrow = '\u2192';
export const rightLeftArrow = '\u2194';
export const shiftKeySymbol = '\u21e7';
export const nonBreakableHyphen = '\u2011';
export const plusKeySymbol = '\u002b';
export const minusKeySymbol = '\u2212';
